function cov_b1znofi6g() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/UserDetails.tsx";
    var hash = "acfece0cede526d41eecec6328aefc5c762a8a66";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/components/global/UserDetails.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 19,
                    column: 20
                },
                end: {
                    line: 19,
                    column: 49
                }
            },
            "1": {
                start: {
                    line: 20,
                    column: 25
                },
                end: {
                    line: 20,
                    column: 53
                }
            },
            "2": {
                start: {
                    line: 22,
                    column: 49
                },
                end: {
                    line: 78,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 24,
                    column: 15
                },
                end: {
                    line: 24,
                    column: 31
                }
            },
            "4": {
                start: {
                    line: 25,
                    column: 18
                },
                end: {
                    line: 25,
                    column: 31
                }
            },
            "5": {
                start: {
                    line: 26,
                    column: 18
                },
                end: {
                    line: 26,
                    column: 31
                }
            },
            "6": {
                start: {
                    line: 28,
                    column: 47
                },
                end: {
                    line: 31,
                    column: 2
                }
            },
            "7": {
                start: {
                    line: 32,
                    column: 34
                },
                end: {
                    line: 35,
                    column: 2
                }
            },
            "8": {
                start: {
                    line: 37,
                    column: 17
                },
                end: {
                    line: 40,
                    column: 3
                }
            },
            "9": {
                start: {
                    line: 42,
                    column: 16
                },
                end: {
                    line: 53,
                    column: 2
                }
            },
            "10": {
                start: {
                    line: 43,
                    column: 2
                },
                end: {
                    line: 52,
                    column: 3
                }
            },
            "11": {
                start: {
                    line: 44,
                    column: 3
                },
                end: {
                    line: 44,
                    column: 54
                }
            },
            "12": {
                start: {
                    line: 46,
                    column: 3
                },
                end: {
                    line: 46,
                    column: 28
                }
            },
            "13": {
                start: {
                    line: 47,
                    column: 3
                },
                end: {
                    line: 47,
                    column: 30
                }
            },
            "14": {
                start: {
                    line: 49,
                    column: 3
                },
                end: {
                    line: 51,
                    column: 6
                }
            },
            "15": {
                start: {
                    line: 55,
                    column: 25
                },
                end: {
                    line: 57,
                    column: 2
                }
            },
            "16": {
                start: {
                    line: 56,
                    column: 2
                },
                end: {
                    line: 56,
                    column: 28
                }
            },
            "17": {
                start: {
                    line: 59,
                    column: 1
                },
                end: {
                    line: 77,
                    column: 3
                }
            },
            "18": {
                start: {
                    line: 80,
                    column: 0
                },
                end: {
                    line: 80,
                    column: 40
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 22,
                        column: 49
                    },
                    end: {
                        line: 22,
                        column: 50
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 73
                    },
                    end: {
                        line: 78,
                        column: 1
                    }
                },
                line: 22
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 42,
                        column: 16
                    },
                    end: {
                        line: 42,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 42,
                        column: 22
                    },
                    end: {
                        line: 53,
                        column: 2
                    }
                },
                line: 42
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 55,
                        column: 25
                    },
                    end: {
                        line: 55,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 55,
                        column: 31
                    },
                    end: {
                        line: 57,
                        column: 2
                    }
                },
                line: 55
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 43,
                        column: 2
                    },
                    end: {
                        line: 52,
                        column: 3
                    }
                },
                type: "if",
                locations: [{
                        start: {
                            line: 43,
                            column: 2
                        },
                        end: {
                            line: 52,
                            column: 3
                        }
                    }, {
                        start: {
                            line: 45,
                            column: 9
                        },
                        end: {
                            line: 52,
                            column: 3
                        }
                    }],
                line: 43
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0
        },
        b: {
            "0": [0, 0]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "acfece0cede526d41eecec6328aefc5c762a8a66"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_b1znofi6g = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_b1znofi6g();
import { bindActionCreators } from '@reduxjs/toolkit';
import { WebAuth } from 'auth0-js';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Avatar, Dropdown, DropdownButton } from 'vio-components';
import { ROUTES } from 'vio-constants';
import { getAuth0ClientId, getAuth0Domain, removeAuth0VaporCookie } from 'vio-libs';
import { requestRemoveServerSideCookie, resetApplication } from '../../redux';
const consumerAPI = (cov_b1znofi6g().s[0]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.consumer_api_rollout);
const useSessionCookie = (cov_b1znofi6g().s[1]++, vaporio === null || vaporio === void 0 ? void 0 : vaporio.server_side_cookies);
cov_b1znofi6g().s[2]++;
const UserDetails = ({ email, picture }) => {
    cov_b1znofi6g().f[0]++;
    const { t } = (cov_b1znofi6g().s[3]++, useTranslation());
    const dispatch = (cov_b1znofi6g().s[4]++, useDispatch());
    const navigate = (cov_b1znofi6g().s[5]++, useNavigate());
    const requestRemoveServerSideCookieDispatch = (cov_b1znofi6g().s[6]++, bindActionCreators(requestRemoveServerSideCookie, dispatch));
    const resetApplicationDispatch = (cov_b1znofi6g().s[7]++, bindActionCreators(resetApplication, dispatch));
    const webAuth = (cov_b1znofi6g().s[8]++, new WebAuth({
        clientID: getAuth0ClientId(vaporio),
        domain: getAuth0Domain(vaporio)
    }));
    cov_b1znofi6g().s[9]++;
    const logout = () => {
        cov_b1znofi6g().f[1]++;
        cov_b1znofi6g().s[10]++;
        if (useSessionCookie) {
            cov_b1znofi6g().b[0][0]++;
            cov_b1znofi6g().s[11]++;
            requestRemoveServerSideCookieDispatch(consumerAPI);
        }
        else {
            cov_b1znofi6g().b[0][1]++;
            cov_b1znofi6g().s[12]++;
            removeAuth0VaporCookie();
            cov_b1znofi6g().s[13]++;
            resetApplicationDispatch();
            cov_b1znofi6g().s[14]++;
            webAuth.logout({
                returnTo: `${window.location.origin}/auth`
            });
        }
    };
    cov_b1znofi6g().s[15]++;
    const routeToSettings = () => {
        cov_b1znofi6g().f[2]++;
        cov_b1znofi6g().s[16]++;
        navigate(ROUTES.SETTINGS);
    };
    cov_b1znofi6g().s[17]++;
    return React.createElement("div", {
        id: "user-details"
    }, React.createElement(Avatar, {
        src: picture,
        defaultSrc: require('../../../images/png/default-avatar.png')
    }), React.createElement(DropdownButton, {
        id: "user-details-dropdown",
        align: "end",
        title: email,
        variant: "outline-link"
    }, React.createElement(Dropdown.Item, {
        onClick: routeToSettings
    }, t('SETTINGS')), React.createElement(Dropdown.Item, {
        onClick: logout
    }, t('LOGOUT'))));
};
cov_b1znofi6g().s[18]++;
UserDetails.displayName = 'UserDetails';
export default UserDetails;
